import { render } from "./CenterDropdown.vue?vue&type=template&id=2db522a1"
import script from "./CenterDropdown.vue?vue&type=script&lang=js"
export * from "./CenterDropdown.vue?vue&type=script&lang=js"

import "./CenterDropdown.vue?vue&type=style&index=0&id=2db522a1&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__